export default __webpack_public_path__ + "static/media/collapse-usage-2.76b2b98a.svg";